import { render, staticRenderFns } from "./ArticleTimelineReaction.vue?vue&type=template&id=f15e8972&"
import script from "./ArticleTimelineReaction.vue?vue&type=script&lang=ts&"
export * from "./ArticleTimelineReaction.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTimelineReaction.vue?vue&type=style&index=0&id=f15e8972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports